export const locale = {
    lang: 'en',
    data: {
      'CIERRE': {
         'LABEL1': 'Survey in progress',
         'LABEL2': 'See progress',
         'LABEL3': 'Survey completed',
         'LABEL4': 'See result',
         'BTN_CIERRE': 'Close now',
         'ALERT':{
           'MESSAGE': 'Do you confirm to perform the anticipated survey close?',
           'BTN_CONFIRM': 'Yes',
           'BTN_CANCEL': 'No'
         },
         'LINK': 'Go to the next link to see the survey current progress',
         'ACTIONS':{
           'TITULO': 'Actions',
           'WANNADO': 'What do you want to do?'
         },
         'COMPLETO':{
           'TAG': 'The survey is finished successfully',
           'CARDTIT': 'Results query',
           'LINK': 'Go to the next link to see the obtained results in the survey'
         }
      },


      'ALERTS':{
        'OK':'OK'
      },
      'CERTIFICAR': {
        'TITUTEST': 'ASDGF',
        'IDIOMAS': {
          'ELEGIR': 'Choose',
          'STATUS': {
            'PEND': 'Complete step',
            'DONE': 'Step completed'
          },
          'MENSAJES':{
            'ADDLANG': 'You chose ',
            'NOADITIONAL': 'You chose not to set additional languages',
            'ERRORADD': 'An error ocurred while choosing the language ',
            'LANGDEL': 'You removed ',
            'NOADITIONALDEL': 'You canceled the option not to set additional languages',
            'ERRORDEL': 'An error ocurred while removing the language ',
            'MAINPICKED': 'You have already chose the survey main language.<br><br>To change it, remove the selected language and choose a new one.'
          },
          'CARD1': {
            'TITULO': 'Main language',
            'ACCION': {
              'PRE': 'You have not selected the main language',
              'POST': 'You selected the language:'
            },
            'MODAL': {
              'TITULO': 'Choose the main language',
              'ACCION': 'Which language is the survey main language?',
              'PLACELISTA': 'Choose a language',
              'BOTONES': {
                'BACK': 'Back',
                'OK': 'Ready'
              }
            }
          },
          'CARD2': {
            'TITULO': 'Additional languages',
            'ACCION': {
              'PRE': 'You have not selected additional languages',
              'SINADIC': 'The survey will not have additional languages',
              'POST': 'You selected the following languages:'
            },
            'MODAL': {
              'TITULO': 'Choose additional languages',
              'ACCION': 'Which languages you want to add to the survey?',
              'BOTONES': {
                'BACK': 'Back',
                'OK': 'Ready'
              }
            }
          }
        },
        'DEMOGRAFICOS': {
            'TAB1': 'Demographic',
            'TAB2': 'Translate',
            'TAB3': 'Preview',
            'COMPLETAR_PASO': 'Complete step',
            'PASO_COMPLETADO': 'Step completed',
            'SELECT': 'Select an option',
            'BTN_DEMOGRAFICOS': 'Accept',
            'OPTION_SURVEY': 'Survey',
            'OPTION_EXCEL': 'Excel',
            'CONFIGURE_QUESTION': 'Click here to configure question',
            'QUESTION': 'Question',
            'OPCIONES_RESPUESTA': 'Response options',
            'STATUS': {
              'PEND': 'Complete step',
              'DONE': 'Step completed'
            }
        },
        'FORALL': {
          'MSJ_PRACTICEREGISTERED': 'Practice saved succesfully',
          'MSJ_DESCRIPTIONREGISTERED': 'Description saved succesfully',
          'MSJ_TRANSLATEREGISTERED': 'Practice translated successfully',
          'MSJ_DESCRIPTIONTRANSLATED': 'Description translated successfully',
          'QUESTIONUPDATEDOK': 'Question updated successfully.',
          'QUESTIONUPDATEDFAIL': 'Error, insert a valid question',
          'RESPONSEUPDATEDOK': 'Response updated successfully.',
          'RESPONSEUPDATEDFAIL': 'Error, insert a valid response text',
          'TRANSLATEDOK': 'Question translate saved succesfully',
          'INSERTTRANSLATE': 'Please, insert the translate',
          'OPTIONTRANSLATED': 'Option translate saved succesfully',
          'INSERTOPTIONTRANSLATE': 'Please, insert the translate',
          'MJS_SELECTOPTION': 'Please select an option',
          'MJS_OPTIONADDED': 'Demographic added correctly',
          'OPTIONDELETED': 'Demographic deleted succesfully',
          'DEMOGRAPHICEXIST': 'The demographic selected already exist',
          'AGREGADEMOGRAFICO': 'Select to add more demographics',


          'SELECCIONE': 'Select a language to show the preview',
          'IDIOMAS_NOT_SELECTED': 'Additional languajes not selected to translate.',
          'PLACEHOLDER': 'Language',
          'DESC_TRANSLATE': 'Enter description translate',
          'PRACTICE_TRANSLATE': 'Enter practice translate',
          'IDIOMAS': {
              'Native': 'Native',
              'es': 'Spanish',
              'zh1': 'Traditional Chinese',
              'zh2': 'Simplified Chinese',
              'pt': 'Portuguese',
              'en': 'English',
              'vi': 'Vietnamese'
            },
            'RESPUESTAS': {
                'Native': 'Nativo',
                'es':{'si': 'SÍ',
                      'no':'NO',
                      'casifalso':'Casi siempre es falso',
                      'false': 'Frecuentemente es falso',
                      'avecesfalse': 'A veces es falso / A veces es verdad',
                      'casiverdad': 'Frecuentemente es verdad',
                      'verdad': 'Casi siempre es verdad'},
                'zh1':{'si': '对','no':'没有',
                      'casifalso':'从来不是这样',
                      'false': '经常不是这样',
                      'avecesfalse': '有时是\有时不是',
                      'casiverdad': '经常是这样',
                      'verdad': '总是这样'},
                'zh2':{'si': '对','no':'没有',
                      'casifalso':'從來不是這樣',
                      'false': '經常不是這樣',
                      'avecesfalse': '有時是\有時不是',
                      'casiverdad': '經常是這樣',
                      'verdad': '總是這樣'},
                'pt':{'si': 'SI','no':'não',
                      'casifalso':'Casi siempre es falso',
                      'false': 'Freqüentemente é falso',
                      'avecesfalse': 'A veces es falso / A veces es verdad',
                      'casiverdad': 'Freqüentemente es verdad',
                      'verdad': 'Casi siempre es verdad'},
                'en':{'si': 'YES','no':'NO',
                      'casifalso':'Almost always untrue',
                      'false': 'Often untrue',
                      'avecesfalse': 'Sometimes untrue/ sometimes true',
                      'casiverdad': 'Often true',
                      'verdad': 'Almost always true'}
              },
          'STATUS': {
            'PEND': 'Complete step',
            'DONE': 'Step completed'
          },
          'TABLA': {
            'TITULOS': {
              'DEFAULT': 'Main language',
              'TRADUCCION': 'Translations',
              'PREVIEW': 'Preview'
            },
            'ENCABEZADOS': {
              'PRACT': 'Practice',
              'DESCR': 'Description',
              'STT1': 'Statement 1',
              'STT2': 'Statement 2',
              'LANG': 'Language'
            },
            'INPUTS': {
              'PRACT': 'Enter the practice text',
              'DESCR': 'Enter the description text'
            }
          }
        },
        'ADICIONALES': {
          'STATUS': {
            'PEND': 'Complete step',
            'DONE': 'Step completed'
          },
          'TABS': {
            'QUESTIONS': 'Additional questions',
            'TRANSLATE': 'Translations',
            'PREVIEW': 'Preview'
          },
          'PREGUNTAS':{
            'STATUS': {
              'SIN': 'You have not created any additional questions',
              'CON': 'Questions created:',
              'NOADICIONALES': 'You choose not to create additional questions',
              'CANCELNOADIC': 'You canceled the option not to create additional questions',
              'ERROR': 'An error occurred while performing the operation'
            },
            'ACCIONES': {
              'ADD': 'Create a question',
              'SIN': 'The survey will not have additional questions'
            },
            'WIZARD': {
              'NEW': 'New question',
              'TIPOTITU': 'Click here to configure the additional question',
              'TIPO': {
                'OPEN': 'Open question',
                'UNI': 'Single option question',
                'MULT': 'Multiple option question'
              },
              'FORM': {
                'TIPO': 'Type of question',
                'TOOLTIP': {
                  'REMOVE': 'Remove this question'
                },
                'MENSAJES': {
                  'BORRAR': 'Do you want to delete this additional question?',
                  'PREG_OK': 'The question was saved successfully',
                  'PREG_ERR': 'An error occurred while saving the question',
                  'PREG_MOD_OK': 'The question was modified correctly',
                  'PREG_MOD_ERR': 'An error occurred while modifying the question',
                  'OPC_OK': 'The answer option was saved successfully',
                  'OPC_ERR': 'An error occurred while saving the answer option',
                  'OPC_MOD_OK': 'The answer option was modified correctly',
                  'OPC_MOD_ERR': 'An error occurred while modifying the answer option',
                  'PREG_DEL_OK': 'The question was deleted successfully',
                  'PREG_DEL_ERR': 'An error occurred while deleting the question',
                  'OPC_DEL_OK': 'The answer option was deleted successfully',
                  'OPC_DEL_ERR': 'An error occurred while deleting the answer option'
                },
                'BOTONES':{
                  'SI': 'Yes',
                  'NO': 'No'
                }
              },
              'ABIERTA': {
                'TITULO': 'New open question',
                'ACCION': 'Enter the question text',
                'ERROR': 'You have not entered the question text'
              },
              'MULTI':{
                'TITULOSING': 'New single option question',
                'TITULOMULT': 'New multiple option question',
                'ACCION': 'Enter the question text',
                'ERROR': 'You have not entered the question text',
                'MENSAJES': {
                  'BORRAR': 'Do you want to delete this answer option?',
                  'SINPREG': 'You cannot enter any option until you enter the question text',
                  'SINANTE': 'You cannot enter this answer option text until you enter the previous answer option text'
                },
                'OPCIONES': {
                  'TITU': 'Answer options',
                  'INPUT': {
                    'TITU': 'Answer option',
                    'ERROR': 'You have not entered the text for the answer option'
                  }
                },
                'TOOLTIP': {
                  'ADD': 'Add an answer option',
                  'MOVE': 'Move answer option',
                  'REMOVE': 'Remove this answer option'
                }
              }
            }
          },
          'TRADUCCIONES': {
            'TITULO': 'Select a language to start entering the translation texts',
            'TITULOALTERNO': 'You did not select any additional language in the "Languages" section',
            'NOTYET': 'Translation not yet completed.',
            'MAIN': 'Main language',
            'INPUT': {
              'NEW': 'Enter the question translation',
              'ERROR': 'You have not entered the question translation!',
              'NEWOPC': 'Enter the answer option translation',
              'ERROROPC': 'You have not entered the answer option translation!'
            },
            'MENSAJES': {
              'PREG_OK': 'The translation text was saved successfully',
              'PREG_ERR': 'An error occurred while saving the translation text',
              'PREG_MOD_OK': 'The translation text was updated correctly',
              'PREG_MOD_ERR': 'An error occurred while updating the translation text',
              'OPC_NOPREG': 'The translation text for this option cannot be saved until the question text is set',
              'OPC_OK': 'The translation text was saved successfully',
              'OPC_ERR': 'An error occurred while saving the translation text',
              'OPC_MOD_OK': 'The translation text was updated correctly',
              'OPC_MOD_ERR': 'An error occurred while updating the translation text'
            },
            'COMPLETE': 'Translation complete '
          },
          'PREVIEW': {
            'TITULO': 'Select a language to show the additional questions translations',
            'SINPREV': 'There are not translated texts for the selected language',
            'LOADING': 'Loading data',
            'INPUT': {
              'RESPABIERTA': 'Write your answer',
              'ERRORABIERTA': 'You have not written your answer!',
              'ELIGELANG': 'Choose a language'
            },
            'HELP': {
              'SINGLE': 'You may choose only an option in this question',
              'MULTI': 'You may choose more than one option in this question'
            }
          }
        },
        'COLABORADORES': {
          'TITULO':'Download work center sheet',
          'TITULOCT':'Work center list',
          'SHEET':{
            'NUMBER':'Sheet name'
          },

          'STATUS': {
            'PEND': 'Complete step',
            'DONE': 'Step completed',
            'LOCK': 'Reopen passage',
          },
          'STATUSBAR': {
            'NOBD': 'You have not loaded your participants database',
            'PROCES': 'The participants database is not stored yet',
            'ERROR': 'Errors were found in the loaded file',
            'OK': 'The participants database is correctly stored'
          },
          'CARD_BD': {
            'TITULO': 'Information: ',
            'NUMCOLABS': 'Number of participants',
            'NUMCENTER': 'Number of work centers',
            'FECHA': 'Upload date',
            'ACCIONES': 'Actions: ',
            'WANNADO': 'What do you want to do?',
            'BOTONES': {
              'DESCARGA': 'Download the participants database',
              'ELIMINA': 'Delete the participants database'
            }
          },
          'CARD_NOBD': {
            'TITULO': 'Follow this steps to upload your participants information into CULTURAL GO®',
            'PASOS': {
              '1': 'Download the participants database template',
              '2': 'Fill the template with your participants information based on the provided columns',
              '3': 'Upload the file with your participants information'
            },
            'TOOLTIP': 'This file includes data validation macros'
          },
          'CARD_NOERR': {
            'TITULO': 'Information',
            'NUMCOLABS': 'Number of participants in the loaded file',
            'NUMCT': 'Number of work center in the loaded file',
            'FILENAME': 'Name of file',
            'GUARDAR': 'Do you want to store this information?',
            'BOTONES': {
              'SI': 'Yes',
              'NO': 'No'
            }
          },
          'CARD_ERRFND': {
            'TITULO': 'Information',
            'ROWS_OK': 'Number of correct rows',
            'ROWS_NOTOK': 'Number of rows with errors',
            'MOREINFO': '* The error list in detail is shown below',
            'FILENAME': 'Name of file',
            'GUARDAR': 'The loaded information cannot be stored',
            'DELETE': 'Delete file'
          },
          'CARD_ERRLIST': {
            'TITULO': {
              '1': 'Rows with errors: ',
              '2': 'Total errors found: ',
              '3': 'Participants data '
            },
            'INFO': {
              'ROW': 'Row ',
              'ERRNUM': 'Number of errors: ',
              'SHOW': 'Click here to show this row errors'
            },
            'DETALLE': {
              'TIPO': 'Type of error',
              'DESCR': 'Description',
              'COLUMNA': 'Column',
              'DATO': 'Wrong data'
            },
            'ERRORES': {
              'alfabetica': 'Alphabetic invalid data',
              'alfanumerica': 'Alphanumeric invalid data',
              'numerica': 'Numerical invalid data',
              'email': 'Email invalid syntax',
              'vacio': 'Empty cell',
              'columna': 'Unknown column',
              'CT': 'Work center not found',
              'catSurvey': 'Unknown data',
              'repetido': 'Collaborator key is duplicate',
              'repetidoMail': 'Email is duplicated',
              'clavenumerica':'Invalidez de clave',

            },
            'DESCRIPCION': {
              'alfabetica': 'The information has one or more invalid characters. Only alphabetic characters (A - Z) and the next special characters: [( ) . , : -] are allowed ',
              'alfanumerica': 'The information has one or more invalid characters. Only alphabetic characters (A - Z), numerical (0 - 9) and the next special characters: [( ) . , : -] are allowed ',
              'numerica': 'The information has one or more invalid characters. Only numerical characters (0 - 9) are allowed',
              'email': 'The information does not have the right email syntax ( mail@domain.com )',
              'vacio': 'The cell has no information. This column is mandatory.',
              'columna': 'The column does not belong to the template provided by CulturalGO',
              'CT': 'The specified work center in this row was not found in the available work center list',
              'catSurvey': 'The information does not match with catalogue',
              'repetido': 'The employer key can not be duplicated',
              'repetidoMail': 'The email can not be duplicated',
              'clavenumerica':'The information has one or more invalid characters. Only alphabetic characters (A - Z), numerical characters (0 - 9) are allowed to, and  and the next special character: -',

            }
          },
          'CARD_LOAD': {
            'CARGA': {
              'TITULO': 'Loading',
              'INFO': 'Analyzing the file information, wait a moment please'
            },
            'GUARDA': {
              'TITULO': 'Saving',
              'INFO': 'Storing the information into the system, stay in this screen until the saving process is finished'
            },
          },
          'MENSAJES': {
            'GUARDA_1': 'Do you confirm to store the information of ',
            'GUARDA_2': ' participants and work centers respectively?',
            'GUARDADO': 'The participants database was stored successfully',
            'GUA_ERR': 'An error occurred while storing the information. Try again later',
            'DELETE_1': 'Do you confirm to delete the information of ',
            'DELETE_2': ' participants and work centers respectively?',
            'DEL_OK_1': 'The information ',
            'DEL_OK_2': ' was deleted successfully',
            'DEL_ERR': 'An error occurred while deleting the participants database. Try again later',
            'DELFILE': 'The database file was remove correctly',
            'EXCEL': 'Generating excel file, wait a moment please',
            'EXTMAL': 'The selected file does not have the right extension. Only uploading the template file provided by CulturalGO is allowed',
            'NOROWS': 'The selected file does not have any record',
            'VACIO': 'The selected file is empty, or the participants information is not in the first sheet',
            'BOTONES': {
              'SI': 'Yes',
              'NO': 'No'
            }
          },
          'EXCELINFO': {
            'HOJA': 'Participants data',
            'TITULO': 'Participants database',
            'AUTOR': 'CulturalGO',
            'ASUNTO': 'Downloaded from platform'
          },
          'UPLOAD': 'Click here to browse the participants database',
          'REMOVE': 'Remove from upload',
          'SEND': 'Send to database',
          'PROCESO': {
            'STP1': 'Analyzing the participants database',
            'STP2': 'Saving the participants database'
          }
        }
      },
      'PDF':{
        'TITLE':'Evidence catalog for the NOM-035-STPS-2018',
        'IND':'Index',
        'MAIN1':'I. Objective',
        'MAIN2':'II. Scope',
        'MAIN3':'III. Evidence',
        'INCISOA':'a) Documentary evidence of the psychosocial risk prevention policy ',
        'INCISOB':'b) Information from the applied questionnaire',
        'INCISOC':'c) Information on prevention measures for psychosocial risk factors',
        'INCISOD':'d) Information on the control measures adopted in the workplace',
        'INCISOE':'e) Information on actions taken to identify workers',
        'INCISOF':'f) Information on the care provided to exposed workers',
        'INCISOH':'g) Records of actions carried out on workers',
        'PARRAFO1':'Provide in a single document the access links to the evidence requested in point 10 "procedure for conformity assessment" of NOM-035-STPS-2018 ',
        'PARRAFO2':'This document compiles the evidence that is added to the CGO platform according to point 10 of NOM-035-STPS-2018.',
        'SECCION1':'CGO Seccion',
        'SECCION2':'Comments',
        'SECCION3':'Link',
        'BTN':'Create PDF'
      },
      'TIMELINE':{
        'ETAPA1':{
          'SECCION1':{
            'actividad': "Generate a psychosocial risk prevention policy contemplating prevention of psychosocial risk factors and workplace violence, promoting a favorable organizational environment.",
            'entregable': "Policy.",

          },
          'SECCION2':{
            'actividad':"Generate survey process and define survey conduct records.",
            'entregable': "Process Flow.",
          },
          'SECCION3':{
            'actividad': "Generate survey process and define survey conduct records.",
            'entregable': "Process Flow.",

          },
          'SECCION4':{
            'actividad': "Generate organizational development plan fostering a culture of prevention and fostering a favorable organizational environment.",
            'entregable': "Campaign 'Promotion of NOM-035', implementation schedule and activities to be carried out.",

          },
          'SECCION5':{
            'actividad': "Dissemination campaign on psychosocial risk prevention policies, measures adopted, prevention of possible work risks and the mechanism for complaints.",
            'entregable': "Campaign 'Promotion of NOM-035', implementation schedule and activities to be carried out.",

          },
          'SECCION6':{
            'actividad': "Use of CGO for the repository of records and monitoring of workers.",
            'entregable': "Worker records.",
          },
          'SECCION7':{
            'actividad': "Use of CGO for the repository of records and monitoring of workers.",
            'entregable': "Job profile.",
          },
          'SECCION8':{
            'actividad': "Use of CGO for the repository of records and monitoring of workers.",
            'entregable': "Job profile.",
          },
          'SECCION9':{
            'actividad': "Use of CGO for the repository of records and monitoring of workers.",
            'entregable': "Job profile.",
          },
          'SECCION10':{
            'actividad': "Hotline process with definition of negative leadership and negative work relationships.",
            'entregable': "Process Flow.",
          },
          'SECCION11':{
            'actividad': "Evaluation process of the favorable organizational environment.",
            'entregable': "Process Flow.",
          },
          'SECCION12':{
            'actividad': "Integration of GPTW culture in staff.",
            'entregable': "Campaign 'Promotion of NOM-035', implementation schedule and activities to be carried out.",
          },
          'SECCION13':{
            'actividad': "Job profiles with risk analysis in the work area.",
            'entregable': "Job profile.",
          },
          'SECCION14':{
            'actividad': "Job profiles with risk analysis in the work area.",
            'entregable': "Job profile.",
          },
          'SECCION15':{
            'actividad': "Generate safety and hygiene tour process and its report.",
            'entregable': "Process Flow.",

          },
          'SECCION16':{
            'actividad': "NOM-035 Survey Process.",
            'entregable': "Process Flow.",

          },
          'SECCION17':{
            'actividad': "Dissemination campaign on psychosocial risk prevention policies, measures adopted, prevention of possible work risks and the mechanism for complaints.",
            'entregable': "Campaign 'Promotion of NOM-035', implementation schedule and activities to be carried out.",

          },
          'SECCION18':{
            'actividad': "Complaints line process.",
            'entregable': "Process Flow.",
          },
          'SECCION19':{
            'actividad': "Actions and programs for the prevention of psychosocial risk factors, the promotion of a favorable organizational environment and the prevention of workplace violence.",
            'entregable': "Campaign 'Promotion of NOM-035', implementation schedule and activities to be carried out.",
          }

        },
        'ETAPA2':{
          'SECCION1':{
            'actividad': "Generate a process for the channeling of workers with severe traumatic events that were identified in the survey.",
            'entregable': "Process Flow.",

          },
          'SECCION2':{
            'actividad'  : "Generate a process for the channeling of workers with severe traumatic events that were identified in the survey.",
            'entregable': "Process Flow.",

          },
          'SECCION3':{
            'actividad'  : "Process for communication of results.",
            'entregable': "Process Flow.",

          },
          'SECCION4':{
            'actividad'  : "Generate survey process and define survey conduct records.",
            'entregable': "Process Flow.",

          },
          'SECCION5':{
            'actividad'  : "Annual training plan and link corrective actions and continuous improvement.",
            'entregable': "Annual training plan, corrective action process flow.",

          },
          'SECCION6':{
            'actividad'  : "Internal communication policy.",
            'entregable': "Policy",

          },
          'SECCION7':{
            'actividad'  : "Internal communication policy.",
            'entregable': "Policy",

          },
          'SECCION8':{
            'actividad'  : "Training plan.",
            'entregable': "Annual training plan.",

          },
          'SECCION9':{
            'actividad'  : "Internal communication policy.",
            'entregable': "Policy",

          },
          'SECCION10':{
            'actividad'  : "Recognition systems.",
            'entregable': "Recognition policy and mechanisms.",

          },
          'SECCION11':{
            'actividad'  : "NOM-035 Survey Process.",
            'entregable': "Process Flow.",

          },
          'SECCION12':{
            'actividad'  : "It does not apply because the standard survey is used.",
            'entregable': "N/A.",

          },
          'SECCION13':{
            'actividad'  : "Job profiles with risk analysis in the work area.",
            'entregable': "Job profile.",

          },
          'SECCION14':{
            'actividad'  : "Job profiles with risk analysis in the work area.",
            'entregable': "Job profile.",

          },
          'SECCION15':{
            'actividad'  : "It is generated by the CGO platform.",
            'entregable': "Report.",

          },
          'SECCION16':{
            'actividad'  : "Communicate the results of the psychosocial risk assessment.",
            'entregable': "Process flow and policy.",

          },
          'SECCION17':{
            'actividad'  : "Organizational development plan to improve communication, sense of belonging, participation in continuous improvement, evaluation and recognition of performance.",
            'entregable': "Organizational development plan.",

          },
          'SECCION18':{
            'actividad'  : "DNC every two years.",
            'entregable': "Process flow, DNC report.",
          },
          'SECCION19':{
            'actividad'  : "Annual training plan and link corrective actions and continuous improvement.",
            'entregable': "Training plan, process flow.",
          },
          'SECCION20':{
            'actividad':"Corrective action process and its adaptation to NOM-035.",
            'entregable':"Process Flow.",
          }
        }

      }

    }
};
